/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ tld: NonNullable<unknown> }} Tld_Pricing_Costs_TitleInputs */

const id_tld_pricing_costs_title = /** @type {(inputs: Tld_Pricing_Costs_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Harga ${i?.tld}`)
};

const en_tld_pricing_costs_title = /** @type {(inputs: Tld_Pricing_Costs_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.tld} pricing`)
};

/**
* | output |
* | --- |
* | "{tld} pricing" |
*
* @param {Tld_Pricing_Costs_TitleInputs} inputs
* @param {{ locale?: "id" | "en" }} options
* @returns {LocalizedString}
*/
export const tld_pricing_costs_title = /** @type {((inputs: Tld_Pricing_Costs_TitleInputs, options?: { locale?: "id" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tld_Pricing_Costs_TitleInputs, { locale?: "id" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tld_pricing_costs_title(inputs)
	return id_tld_pricing_costs_title(inputs)
});